import { render, staticRenderFns } from "./ProductAnalysis.vue?vue&type=template&id=be03bbfe&scoped=true&"
import script from "./ProductAnalysis.vue?vue&type=script&lang=js&"
export * from "./ProductAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ProductAnalysis.vue?vue&type=style&index=0&id=be03bbfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be03bbfe",
  null
  
)

export default component.exports